import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiAdd = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M11 19V13H5V11H11V5H13V11H19V13H13V19H11Z" />
  </SvgWrapper>
);
